// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pg4P","list":"styles_list__10J-P"};